import { jotaiStore } from '@shared/store/jotai/jotai-store';

import { voucherAtom } from '@entities/voucher/store/voucher.atom';
import type { VoucherState } from '@entities/voucher/model/types';

const applyVoucher = (next: (prev: VoucherState) => VoucherState): void => {
  jotaiStore.set(voucherAtom, next);
};

export const writeVoucherBtnLoading = (btnLoading: boolean): void => {
  applyVoucher((prev) => ({ ...prev, btnLoading }));
};

export const writeVoucherSubscribeResult = (voucherRes: unknown): void => {
  applyVoucher((prev) => ({ ...prev, btnLoading: false, voucherRes }));
};

export const writeVoucherHandledFailure = (): void => {
  applyVoucher((prev) => ({ ...prev, btnLoading: false, error: null }));
};

export const writeVoucherResendTimerTick = (): void => {
  applyVoucher((prev) => ({
    ...prev,
    timerActive: false,
    timerCount: prev.timerCount + 1,
  }));
};

export const resetVoucherTimer = (): void => {
  applyVoucher((prev) => ({ ...prev, timerActive: true }));
};
